var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkFill = function SvgBookmarkFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6.53 1c-.68 0-1.357.229-1.877.671-.523.446-.853 1.085-.853 1.788v18.62a.908.908 0 0 0 1.496.692L12 17.065l6.704 5.706a.908.908 0 0 0 1.496-.691V3.46c0-.704-.33-1.343-.853-1.789l-.341.4.34-.4A2.9 2.9 0 0 0 17.47 1z",
    clipRule: "evenodd"
  })));
};
export default SvgBookmarkFill;